import { defineMessages } from '@dragonraider5/react-intl'

export default defineMessages({
  sectionTitle: {
    id: 'containers.Register.sectionTitle',
    description: 'Register form section title',
    defaultMessage: 'Solicitud y registro'
  },
  welcomeTitle: {
    id: 'containers.Register.welcome.title',
    description: 'Register form welcome text title',
    defaultMessage: 'Bienvenida'
  },
  welcomeTextHTML: {
    id: 'containers.Register.welcome.text',
    description: 'Register form welcome text',
    defaultMessage: `
      <p>En Triodos Bank trabajamos para ayudar a crear una sociedad donde se proteja la calidad de vida de todas las personas y el medio ambiente. Y lo hacemos poniendo la dignidad humana en el epicentro de nuestras actividades. Hacemos banca ética y sostenible.</p>
      <p>Desde 1980 financiamos iniciativas y empresas que con su actividad contribuyen a promover un cambio social, ambiental y cultural positivo. Trabajamos con organizaciones comprometidas y que buscan transmitir sus valores a la sociedad a través de su actividad empresarial y económica.</p>
      <p>Para iniciar el proceso de solictud, debemos comprender tus necesidades, recabar algunos datos básicos de ti y de tu empresa y consultar determinados documentos fiscales y bancarios. Deseamos que el proceso de solicitud de financiación que ahora inicias te resulte sencillo, transparente, eficaz y enriquecedor. Una vez que hayas cumplimentado la información requerida, procederemos a analizar tu iniciativa y nos pondremos en contacto contigo.</p>
    `
  },
  formTitle: {
    id: 'containers.Register.form.title',
    description: 'Register form, form title',
    defaultMessage: 'Comienza tu solicitud digital'
  },
  formFieldName: {
    id: 'containers.Register.form.fields.name',
    description: 'Register form, name field',
    defaultMessage: 'Nombre'
  },
  formFieldLastname: {
    id: 'containers.Register.form.fields.lastname',
    description: 'Register form, lastname field',
    defaultMessage: 'Apellidos'
  },
  formFieldNIF: {
    id: 'containers.Register.form.fields.NIF',
    description: 'Register form, NIF field',
    defaultMessage: 'DNI'
  },
  formFieldPhone: {
    id: 'containers.Register.form.fields.phone',
    description: 'Register form, phone field',
    defaultMessage: 'Teléfono de contacto'
  },
  formFieldUsername: {
    id: 'containers.Register.form.fields.username',
    description: 'Register form, username field',
    defaultMessage: 'E-mail'
  },
  formFieldPassword: {
    id: 'containers.Register.form.fields.password',
    description: 'Register form, password field',
    defaultMessage: 'Contraseña'
  },
  formFieldPower: {
    id: 'containers.Register.form.fields.power',
    description: 'Register form, power field',
    defaultMessage: 'Declaro que tengo poder para iniciar la solicitud de financiación en nombre de la organización o en mi propio nombre.'
  },
  formFieldTerms: {
    id: 'containers.Register.form.fields.terms',
    description: 'Register form, power field',
    defaultMessage: 'Acepto los {termsLink} del servicio y la {privacyLink}.'
  },
  termsLink: {
    id: 'containers.Register.links.terms',
    description: 'Register from, terms link',
    defaultMessage: 'términos y condiciones'
  },
  privacyLink: {
    id: 'containers.Register.links.privacy',
    description: 'Register from, privacy link',
    defaultMessage: 'política de privacidad'
  },
  loginLink: {
    id: 'containers.Register.links.login',
    description: 'Register from, login link',
    defaultMessage: 'Ya tengo usuario y quiero continuar con mi solicitud'
  },
  formButtonSubmit: {
    id: 'containers.Register.form.button.submit',
    description: 'Register form, submit field',
    defaultMessage: 'Comienza tu solicitud'
  },
  formValidationsPower: {
    id: 'containers.Register.form.validations.power',
    description: 'Register form, validations power',
    defaultMessage: 'Recuerda que debes tener poder de representación de la organización para poder solicitar una financiación.'
  },
  formValidationsTerms: {
    id: 'containers.Register.form.validations.terms',
    description: 'Register form, validations terms',
    defaultMessage: 'Debes aceptar los términos y condiciones del servicio y la política de privacidad para poder comenzar la solicitud.'
  },
  successMessageHTML: {
    id: 'containers.Register.success.messageHTML',
    description: 'Register form success message',
    defaultMessage:
      `<p>Gracias por comenzar el proceso de solicitud en nuestra plataforma.</p>
       <p>En breve recibirás un email para confirmar que la dirección introducida corresponde a una dirección de correo electrónico válida. Sigue los pasos descritos en él para continuar con el proceso.</p>`
  },
})
